import React from "react";
import { PageHero, FeatureList } from "../components/PageShells";

const Installatie = () => (
  <main data-testid="install-page">
    <PageHero
      eyebrow="Installatie"
      title="Gecertificeerde monteurs. Strakke afwerking."
      subtitle="Van schouwen tot inbedrijfstelling regelen wij alles. Door heel Nederland, vaak binnen 4 weken na akkoord."
      image="https://images.unsplash.com/photo-1766603636700-e9d80473f40f?crop=entropy&cs=srgb&fm=jpg&q=85"
    />
    <FeatureList
      title="Onze installatieaanpak"
      items={[
        { title: "Gratis schouwen", desc: "Adviseur komt langs voor opname en advies op maat." },
        { title: "Heldere offerte", desc: "Geen verborgen kosten, alles transparant." },
        { title: "Gecertificeerde monteurs", desc: "Eigen team, geen onderaanneming." },
        { title: "1 dag installatie", desc: "Standaard projecten binnen 1 dag opgeleverd." },
        { title: "App-configuratie", desc: "Wij maken de monitoring app voor je werkend." },
        { title: "Nazorg & service", desc: "10 jaar garantie en 24/7 monitoring inbegrepen." },
      ]}
    />
  </main>
);

export default Installatie;
